const getMetaDataValue = (field, key) => (field.metaData.filter(({
  name
}) => name === key)[0] || {}).value;
export default getMetaDataValue;